import React from 'react'
import AppLink from '../../../components/AppLink'

export default function Step3({ orderId }) {
  return (
    <>
      <div className="text-lg text-center mb-2">
        解約申し込みが完了しました。
      </div>
      <div className="text-center mb-4">
        解約番号：{orderId}
      </div>
      <div className="text-center">
        <AppLink to={`/orders/${orderId}/return`}>解約申し込みの詳細ページ</AppLink>
        から、返却先の宛先の確認と、返送用納品書を印刷して商品に同梱し配送手続きを行ってください。
      </div>
    </>
  )
}
